import { render } from "./DateComponent.vue?vue&type=template&id=796f73f4&ts=true"
import script from "./DateComponent.vue?vue&type=script&lang=ts"
export * from "./DateComponent.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__